import { eventChannel, delay } from 'redux-saga';
import { fork, take, call, put, takeLatest, cancel } from 'redux-saga/effects';
import forEach from 'lodash/forEach';
import { getType } from 'typesafe-actions';
import { initiateSocket } from 'utils/socket';

import { signOut } from '@lib/actions';

// TODO refactor
import {
  onSocketMessage,
  onSocketTypingStart,
  onSocketTypingStop,
  onSocketProviderArrived,
  onSocketActivity,
} from './actions';
import {
  REGISTER_SOCKET,
  EMIT_SOCKET_TYPING,
  ON_SOCKET_TYPING_START,
  ON_SOCKET_PROVIDER_ARRIVED,
  EMIT_SOCKET_LOGIN_FROM_QR,
} from './constants';

function onSocketSubscribe(socket) {
  return eventChannel((dispatch) => {
    function subscribeEvents(socketEvents) {
      forEach(socketEvents, (callback, name) => {
        socket.emit('subscribe', name);
        socket.on(name, (data, ackCallback) => {
          dispatch(callback(data));
          ackCallback?.();
        });
      });
    }

    // subscribe events
    subscribeEvents({
      'chat:server:outbound:message': onSocketMessage,
      'chat:client:inbound:message': onSocketMessage,
      'chat:server:typing:start': onSocketTypingStart,
      'chat:server:typing:stop': onSocketTypingStop,
      'telehealth:server:provider:arrived': onSocketProviderArrived,
      'luma:server:activity:create': onSocketActivity,
    });

    return () => {};
  });
}

function* watchSocketRead(socket) {
  const channel = yield call(onSocketSubscribe, socket);
  while (true) {
    // eslint-disable-line no-constant-condition
    const action = yield take(channel);
    yield put(action);
  }
}

function* watchSocketWrite(socket) {
  while (true) {
    // eslint-disable-line no-constant-condition
    const action = yield take([EMIT_SOCKET_TYPING, EMIT_SOCKET_LOGIN_FROM_QR]);

    let eventName;
    switch (action.type) {
      case EMIT_SOCKET_TYPING:
        eventName = 'chat:client:typing:start';
        break;
      case EMIT_SOCKET_LOGIN_FROM_QR:
        eventName = 'login:bydob:start';
        break;
      default:
        break;
    }

    if (eventName) {
      socket.emit(eventName, action.payload);
    }
  }
}

function* watchSocketIO(socket) {
  yield fork(watchSocketRead, socket);
  yield fork(watchSocketWrite, socket);
}

function* watchSocket() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { user } = yield take(REGISTER_SOCKET);
    const socket = yield call(initiateSocket, user._id);
    const task = yield fork(watchSocketIO, socket);

    // Disconnect socket and cancel Redux actions on sign out
    yield take(getType(signOut));
    socket.disconnect();
    yield cancel(task);
  }
}

export function* onWatchSocketTypingStart(action) {
  // hide typing indicator after 5 secs
  yield call(delay, 5000);
  const { data } = action;
  yield put(onSocketTypingStop(data));
}

export function* watchOnSocketTypingStart() {
  yield takeLatest(ON_SOCKET_TYPING_START, onWatchSocketTypingStart);
}

export function* watchOnSocketProviderArrived() {
  yield takeLatest(ON_SOCKET_PROVIDER_ARRIVED, onSocketProviderArrived);
}

export default function* appSaga() {
  yield fork(watchSocket);
  yield fork(watchOnSocketTypingStart);
  yield fork(watchOnSocketProviderArrived);
}
